const ChartSkeleton = () => (
  <div className="ea-skeleton ea-skeleton--chart" aria-hidden="true">
    <div className="ea-skeleton__shimmer" />
  </div>
);

const TableSkeleton = ({ rows = 6 }) => (
  <div className="ea-skeleton ea-skeleton--table" aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="ea-skeleton__row">
        <div className="ea-skeleton__shimmer" />
      </div>
    ))}
  </div>
);

export { ChartSkeleton, TableSkeleton };
